
export default [
  {
    path: '/service',
    name: 'service',
    component: resolve => require.ensure([], () => resolve(require('@/views/singlePage/service.vue')), 'service'),
    meta: { title: '条款服务', icon: '' }
  }
]
